import { useQuery } from "@tanstack/react-query";
import { ordersApi, stationViewApi, stationsApi } from "../api/client";

export function useOrders(clientId: string | null, status?: string) {
  return useQuery({
    queryKey: ["kitchen-orders", clientId, status],
    queryFn: () => ordersApi.list(clientId!, { status }),
    enabled: !!clientId,
    // Polling 5s — allineato al refresh dell'app cliente al tavolo, cosi'
    // un ordine self-service del cliente arriva in vista chef entro pochi
    // secondi anche senza WebSocket broadcast.
    refetchInterval: 5_000,
  });
}

export function useStationOrders(
  stationId: string | null,
  clientId: string | null,
) {
  return useQuery({
    queryKey: ["kitchen-station-orders", stationId, clientId],
    queryFn: () => stationViewApi.get(stationId!, clientId!),
    enabled: !!stationId && !!clientId,
    refetchInterval: 5_000,
  });
}

export function useStations(clientId: string | null) {
  return useQuery({
    queryKey: ["kitchen-stations", clientId],
    queryFn: () => stationsApi.list(clientId!),
    enabled: !!clientId,
    staleTime: 60_000,
  });
}
